<div class="frame-in">
  <div class="items" [ngStyle]="itemsStyle" [ngClass]="{'hidden': loading}">

    <div class="poi" (mouseenter)="mouseEnter(0)" (mouseleave)="mouseLeave(0)" style="bottom: 300px; right: 336px;"
      [ngClass]="{'hover': zones[0].hover, 'lock': zones[0].locked, 'active': zones[0].active}"
      (click)="poiClick(1)">@if (!zones[0].locked) {
      <span>13</span>
    }</div>
    <div class="country iran zone4" [ngClass]="{'hover': zones[0].hover}"></div>

    <div class="poi" (mouseenter)="mouseEnter(1)" (mouseleave)="mouseLeave(1)" style="bottom: 148px; right: 334px;"
      [ngClass]="{'hover': zones[1].hover, 'lock': zones[1].locked, 'active': zones[1].active}"
      (click)="poiClick(2)">@if (!zones[1].locked) {
      <span>14</span>
    }</div>
    <div class="country uae zone4" [ngClass]="{'hover': zones[1].hover}"></div>

    <div class="poi" (mouseenter)="mouseEnter(2)" (mouseleave)="mouseLeave(2)" style="bottom: 182px; right: 436px;"
      [ngClass]="{'hover': zones[2].hover, 'lock': zones[2].locked, 'active': zones[2].active}"
      (click)="poiClick(3)">@if (!zones[2].locked) {
      <span>15</span>
    }</div>
    <div class="country saudi zone4" [ngClass]="{'hover': zones[2].hover}"></div>

    <div class="poi" (mouseenter)="mouseEnter(3)" (mouseleave)="mouseLeave(3)" style="bottom: 258px; right: 628px;"
      [ngClass]="{'hover': zones[3].hover, 'lock': zones[3].locked, 'active': zones[3].active && quizLevel !== 4}"
      (click)="poiClick(4)">@if (!zones[3].locked) {
      <span>16</span>
    }</div>
    <div class="country palestine" [ngClass]="{'hover': zones[3].hover}"></div>

    <div class="poi dark" style="bottom: 350px; right: -43px;"><span>9</span></div>
    <div class="poi dark" style="bottom: 204px; right: 57px;"><span>10</span></div>
    <div class="poi dark" style="bottom: 182px;	right: 258px;"><span>11</span></div>
    <div class="poi dark" style="top: 108px; right: 329px;"><span>12</span></div>

    @if (quizLevel < 4) {
      <div class="quiz-activity zone-4-2"></div>
    }
    @if (quizLevel >= 4) {
      <div class="quiz-activity zone-4-2 active" [ngClass]="{'current': quizLevel === 4 && tick2Quiz}" [routerLink]="['/game/quiz-activity/1-4']"></div>
    }

    <div class="quiz-activity zone-4-1 block"></div>

    <svg class="road zone4">
      <g>
        <path d="M400.5,6.5c-13.77-1-25.35-1.12-34-1-6.2.09-13,.2-22,1-10.11.9-19.34,1.72-31,5-16.5,4.64-23.81,10.24-26,12-5.89,4.74-8.24,8.65-9,10-.9,1.6-3.78,7-4,18-.17,8.62-.4,20.31,7,31,7,10.17,17.26,14.06,25,17,9.72,3.7,21.57,5.54,31,7,.63.1,4.09.73,11,2,10,1.83,13.32,2.49,17,5a24.31,24.31,0,0,1,6,6,32.75,32.75,0,0,1,6,20c-.11,3.83-.95,8.47-10,24-6.94,11.91-9.12,13.76-16,25-7.95,13-11.93,19.49-14,27-1.49,5.42-4.82,18.12,0,33,1.74,5.38,5.22,16.12,15,23,3.79,2.67,11.53,5.78,27,12a29.54,29.54,0,0,1,10,6c1.53,1.45,6.07,6.08,7,13,.29,2.19.61,4.81-1,7-1.75,2.38-4.74,2.82-6,3-2.12.31-5.56.26-13-4a83.61,83.61,0,0,1-10-7c-7.95-6.13-8.85-7.47-14-11a75.46,75.46,0,0,0-10-6c-2.61-1.28-6.19-2.81-18-6-8.69-2.34-8.36-1.95-16-4-12.36-3.32-13.1-4.33-19-5-5.64-.64-11.55-1.23-17,2-2.93,1.74-3.53,3.28-7,7-5,5.38-9.62,8.43-15,12-2.78,1.85-9.89,5.26-24,12-8,3.82-9.4,4.45-12,5-6.46,1.37-11.19.37-19-1-21.95-3.85-18.74-1.91-26-4a89.36,89.36,0,0,1-27-13,91.67,91.67,0,0,1-20-20,114,114,0,0,1-15-26c-4.92-11.89-4.56-16.67-8-30-4.65-18-11.81-45.78-33-62a138.2,138.2,0,0,0-16-10,164.06,164.06,0,0,0-28-13,150.3,150.3,0,0,0-23-6" transform="translate(0.59)" fill-opacity="null" stroke-opacity="null" stroke="#000" fill="none" />
      </g>
    </svg>

    <!-- <div class="plane" [ngClass]="{'to-1': plane.position == 1, 'to-2': plane.position == 2, 'to-3': plane.position == 3, 'to-4': plane.position == 4}"></div> -->

    <audio id="introductionAudio" (ended)="playBgAudio()">
      <source src="assets/sounds/country.wav" type="audio/wav">
    </audio>
    <audio id="bgAudio" (ended)="playIntroductionAudio()">
      <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
    </audio>

    <img class="frame-bg" src="assets/images/zones/4/zone-4-bg.jpg">
  </div>
</div>

<img class="frame-title" src="assets/images/zones/1/title.png">

<div class="footer">
  <ul class="zone-menu">
    <li>
      <a class="menu-item" [routerLink]="[ '/game/zone1' ]" routerLinkActive="active">1</a>
    </li>
    <li>
      @if (!haveAccess('1-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('1-2')) {
        <a class="menu-item" [routerLink]="[ '/game/zone2' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('1-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('1-3')) {
        <a class="menu-item" [routerLink]="[ '/game/zone3' ]" routerLinkActive="active">3</a>
      }
    </li>
    <li>
      @if (!haveAccess('1-4')) {
        <span class="lock"></span>
      }
      @if (haveAccess('1-4')) {
        <a class="menu-item" [routerLink]="[ '/game/zone4' ]" routerLinkActive="active">4</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/4/footer4.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
